<template>
    <v-app class="theme-cc2 vuetify3">
        <v-main class="fill-height" style="padding: 0px;">
            <router-view :key="security?.key"></router-view>
            <error-snackbar />
            <ModalComponent></ModalComponent>
        </v-main>
    </v-app>
</template>

<script>
import ErrorSnackbar from './components/ErrorSnackbar.vue';
import { useSecurity } from './stores/security';
import ModalComponent from './components/Modals/ModalComponent.vue';
import { defineComponent } from 'vue';

export default defineComponent({
    name: "App",
    data() {
        return {
            security: undefined
        }
    },
    async mounted() {
        this.security = await useSecurity();
    },
    components: {
        ErrorSnackbar,
        ModalComponent,
    },
})
</script>

<style>
@import './theme/icons.css';
@import './theme/theme.css';
@import "@vue-flow/core/dist/style.css";
@import "@vue-flow/core/dist/theme-default.css";
</style>
